export const SHOW_SCHEDULE_EDIT_TIME = 'SHOW_SCHEDULE_EDIT_TIME'
export const HIDE_SCHEDULE_EDIT_TIME = 'HIDE_SCHEDULE_EDIT_TIME'